import { render } from "./professionalgoals.vue?vue&type=template&id=de2d939c"
import script from "./professionalgoals.vue?vue&type=script&lang=js"
export * from "./professionalgoals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__